import React from 'react'
import Navigate from '../../components/common/routing/Navigate'
import { liveRoutes } from '../../routing/liveRoutes'

const Live = () => {
  return (<Navigate routes={liveRoutes} />)
}

export default Live
